import { BarChart3, CalendarSearch, ClipboardEdit, Settings, Users, X } from "lucide-react";
import * as React from "react";
import { BreedrLogo } from "./BreedrLogo";
import { BusinessUnitPicker } from "./BusinessUnitPicker";
import { LogoutButton } from "./LogoutButton";
import { type NavItem, NavItems } from "./NavItems";
import { Button } from "./ui/button";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
import { cn } from "@/lib/utils/common";

const menuItems: Array<NavItem> = [
  { title: "Bookings", url: "/bookings", icon: CalendarSearch },
  { title: "Benchmarks", url: "/benchmarks", icon: ClipboardEdit },
  // { name: "Break-evens", path: "/break-evens" },
  { title: "Contacts", url: "/contacts", icon: Users },
  { title: "Reports", url: "/reports", icon: BarChart3 },
  // { name: "Supply Chain", path: "/supply-chain" },
  // { name: "Listings", path: "/listings" },
];

const bottomMenuItems: Array<NavItem> = [{ title: "Settings", url: "/settings", icon: Settings }];

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state, openMobile, isMobile } = useSidebar();

  const showExpandedHeader = state === "expanded" || (state === "collapsed" && openMobile);

  const filteredItems = menuItems.filter((item) => item.isVisible !== false);

  return (
    <Sidebar collapsible="icon" className="z-20" {...props}>
      <SidebarHeader>
        {showExpandedHeader ? <ExpandedHeader /> : <BreedrLogo variant="collapsed" size="xl" className="mx-auto" />}
        {isMobile || state === "collapsed" ? null : (
          <div className="min-h-10">
            <BusinessUnitPicker />
          </div>
        )}
      </SidebarHeader>
      <SidebarContent className={"p-4"}>
        <NavItems items={filteredItems} />
      </SidebarContent>
      <SidebarFooter className={"mb-10 p-4 space-y-4"}>
        <NavItems items={bottomMenuItems} />
        <LogoutButton />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

const ExpandedHeader = () => {
  const { setOpenMobile, openMobile } = useSidebar();

  return (
    <div className={cn("flex-1 flex justify-between", openMobile ? "" : "p-4")}>
      <BreedrLogo variant="default" size={openMobile ? "sm" : "lg"} className="self-center" />

      {openMobile && (
        <Button
          className="h-10 w-10 rounded bg-background hover:bg-background lg:hidden"
          onClick={() => setOpenMobile(false)}
          aria-label="Close main menu"
        >
          <span className="sr-only">Close Menu</span>
          <X className="h-6 w-6 bg-background text-primary" />
        </Button>
      )}
    </div>
  );
};
